import { motion } from "framer-motion";
import { Sparkle, PaperPlaneRight, Lightning } from "@phosphor-icons/react";

const SIGNALS = [
  { color: "#FFB800", text: "Growth round closed — 3 days ago",  meta: "funding" },
  { color: "#CCFF00", text: "Visited pricing page 4× this week",  meta: "intent"  },
  { color: "#D946EF", text: "Added new CRM to tech stack",        meta: "tech"    },
];

export default function AIBriefingVisual() {
  return (
    <div className="w-full h-full flex flex-col justify-center font-mono text-[11px]" data-testid="ai-briefing-visual">
      <div className="flex items-center justify-between mb-3 pb-2 border-b border-white/10">
        <div className="flex items-center gap-2">
          <Sparkle size={14} weight="fill" className="text-[#CCFF00]" />
          <span className="uppercase tracking-[0.25em] text-white font-bold text-[10px]">
            ai_briefing.md
          </span>
        </div>
        <span className="flex items-center gap-2 text-[10px] text-zinc-500 uppercase tracking-wider">
          <span className="h-1.5 w-1.5 rounded-full bg-[#CCFF00] animate-pulse" />
          generated 2m ago
        </span>
      </div>

      <div className="border border-white/10 bg-white/[0.02] p-4 space-y-3">
        <div>
          <div className="text-zinc-500 uppercase tracking-[0.2em] text-[9px] mb-1.5">
            // target_account
          </div>
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 border border-[#00F0FF]/40 flex items-center justify-center text-[#00F0FF] font-bold text-[11px]">
              TA
            </div>
            <div>
              <div className="text-white font-bold text-[12px] leading-none">Target Account</div>
              <div className="text-zinc-500 text-[10px] mt-0.5">
                Series B · SaaS · 420 emp
              </div>
            </div>
            <span className="ml-auto px-2 py-1 border border-[#CCFF00]/40 text-[#CCFF00] text-[9px] uppercase tracking-widest">
              Tier 1
            </span>
          </div>
        </div>

        <div>
          <div className="text-zinc-500 uppercase tracking-[0.2em] text-[9px] mb-2">
            // why_now · composite_score 0.94
          </div>
          <div className="space-y-1.5">
            {SIGNALS.map((s, i) => (
              <motion.div
                key={s.text}
                initial={{ opacity: 0, x: -8 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="flex items-center gap-2.5 text-zinc-200"
              >
                <span
                  className="h-1.5 w-1.5 rounded-full shrink-0"
                  style={{ background: s.color, boxShadow: `0 0 6px ${s.color}` }}
                />
                <span className="text-[10.5px]">{s.text}</span>
                <span className="ml-auto text-zinc-600 text-[9px] uppercase">{s.meta}</span>
              </motion.div>
            ))}
          </div>
        </div>

        <div>
          <div className="text-zinc-500 uppercase tracking-[0.2em] text-[9px] mb-1.5">
            // key_contact
          </div>
          <div className="flex items-center gap-3 border border-dashed border-white/10 p-2">
            <span className="h-7 w-7 border border-white/20 flex items-center justify-center text-white font-bold text-[10px]">
              VP
            </span>
            <div className="flex-1">
              <div className="text-white text-[11px] leading-none">VP Engineering</div>
              <div className="text-zinc-500 text-[9px] mt-0.5">
                Decision maker · 1st-degree connection
              </div>
            </div>
            <Lightning size={12} weight="fill" className="text-[#FFB800]" />
          </div>
        </div>

        <div className="pt-2 border-t border-dashed border-white/10">
          <button
            type="button"
            className="w-full bg-[#CCFF00] text-black font-bold py-2.5 flex items-center justify-center gap-2 uppercase tracking-[0.2em] text-[10px] hover:bg-white transition-colors"
          >
            <PaperPlaneRight size={12} weight="bold" /> Send AI-drafted email
          </button>
          <div className="text-center text-zinc-600 text-[9px] uppercase tracking-wider mt-1.5">
            rep review · 1-click send
          </div>
        </div>
      </div>
    </div>
  );
}
